import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'presentFilter'
})
export class PresentFilterPipe implements PipeTransform {

  transform(items: any[], searchText: string) {
    return items ? items.filter(item => item.complaintName.search(new RegExp(searchText, 'i')) > -1) : [];
    }


}
